<template>
  <div id="top-guide" class="container column is-paddingless-top is-paddingless-bottom">
    <div class="top columns is-vcentered has-bg-white is-border is-radius-large">
      <div class="column columns is-3 is-paddingless is-padding-left">
        <div
          class="column titre is-paddingless-left is-paddingless-right is-padding-top-large is-padding-bottom-large is-margin-right-xlarge"
        >
          <p class="title h1 is-marginless">
            <strong>Guide d'utilisation</strong>
          </p>
        </div>
      </div>
      <div class="columns is-mobile is-paddingless is-padding-right is-padding-left-small column search">
        <div
          class="control column is-border is-padding-top-xsmall is-padding-bottom-xsmall has-bg-light is-radius-top-left-large is-radius-bottom-left-large"
        >
          <input
            v-model="query" type="text" class="input"
            placeholder="Rechercher une rubrique, une fonctionnalité..."
            @input="updateRouteOnInput()" @keydown.enter="updateRouteOnInput()"
          >
        </div>
        <div
          class="control column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall is-radius-top-right-large is-radius-bottom-right-large has-bg-primary"
        >
          <a class="button is-min-width-0 has-text-grey" @click="updateRouteOnInput()">
            <i class="fal fa-search"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MySearchbar',
    data () {
      return {
        requette:'',
        query: null
      }
    },
    watch: {
      $route: 'initComponent'
    },
    created () {
      this.initComponent()
    },
    methods: {
      async initComponent () {
          this.query = this.$route.params.searchQuerry
      },
      updateRouteOnInput () {
        let _this = this
        setTimeout(function () {
          let requette = _this.query
          // remplacer les caracteres spéciaux
          if(requette != 'undefined' && requette != null ){
            _this.$router.replace({ path: `/recherche/${ requette }` }) // push pour garder l'historique
          }
        }, 1000)
      }
    }
  }
</script>
